import { NEW_PASSWORD_ERROR } from "./error-codes.constants";
import ApiError from "../../errors/ApiError";

export class NewPasswordError extends ApiError {
  constructor() {
    super(NEW_PASSWORD_ERROR);
  }
}
